import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactMethods = () => {
  const contactMethods = [
    {
      type: 'phone',
      title: 'Direct Phone',
      subtitle: '',
      icon: 'Phone',
      primary: '647 292 3991',
      secondary: 'Mon-Fri: 8AM-8PM EST',
      action: 'Call Now',
      color: 'text-primary'
    },
    {
      type: 'email',
      title: 'Email Support',
      subtitle: '',
      icon: 'Mail',
      primary: 'kanav@mirakalous.com',
      secondary: 'Detailed inquiries welcome',
      action: 'Send Email',
      color: 'text-innovation-blue'
    },
    {
      type: 'address',
      title: 'Office Address',
      subtitle: '',
      icon: 'MapPin',
      primary: '321 Aztec Drive',
      secondary: 'Oshawa, ON L1J 7T4',
      action: 'Get Directions',
      color: 'text-success'
    }
  ];

  const keyPersonnel = [
    {
      name: 'Kanav Kahol',
      title: 'Founder & AI Architect',
      specialization: 'Enterprise AI Strategy & On-Prem Deployments',
      email: 'kanav@mirakalous.com',
      phone: '647 292 3991',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
      availability: 'Strategic consultations by appointment'
    },
    {
      name: 'Technical Team',
      title: 'Engineering & Development',
      specialization: 'Custom AI Development & Infrastructure',
      email: 'kanav@mirakalous.com',
      phone: '647 292 3991',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
      availability: 'Technical assessments & development consultations'
    },
    {
      name: 'Partnership Team',
      title: 'Strategic Partnerships',
      specialization: 'Technology Partnerships & Collaborations',
      email: 'kanav@mirakalous.com',
      phone: '647 292 3991',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
      availability: 'Partnership opportunities & strategic alliances'
    }
  ];

  // Office locations removed per business decision (no fixed offices currently)

  return (
    <section className="py-20 relative text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Contact Methods */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-extrabold mb-4 bg-gradient-to-r from-white via-blue-200 to-white bg-clip-text text-transparent drop-shadow-[0_4px_20px_rgba(59,130,246,0.35)]">
            Ways to Connect
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Choose the communication method that works best for your schedule and preferences.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {contactMethods?.map((method) => (
            <div
              key={method?.type}
              className="bg-white/10 backdrop-blur-md border border-white/15 rounded-2xl p-8 lg:p-9 text-center shadow-[0_12px_36px_rgba(30,64,175,0.25)] hover:shadow-[0_18px_50px_rgba(59,130,246,0.35)] ring-1 ring-white/10 hover:ring-accent/30 enterprise-transition hover:-translate-y-0.5"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl bg-white/20 ring-1 ring-white/30 shadow-inner mb-6">
                <Icon name={method?.icon} size={28} className="text-white" />
              </div>
              
              <h3 className="text-xl font-extrabold text-white mb-2">{method?.title}</h3>
              {method?.subtitle ? (
                <p className="text-white/80 mb-5">{method?.subtitle}</p>
              ) : null}
              
              <div className="mb-6">
                <p className={`font-bold text-white ${method?.type === 'phone' ? 'text-2xl tracking-wide' : 'text-base break-all'}`}>{method?.primary}</p>
                <p className="text-sm text-white/80">{method?.secondary}</p>
              </div>
              
              {method?.type === 'address' ? (
                <a
                  href="https://maps.google.com/?q=321+Aztec+Drive+Oshawa+ON+L1J+7T4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full"
                >
                  <Button
                    variant="default"
                    fullWidth
                    className="font-semibold bg-white text-primary hover:bg-white/90 rounded-lg text-sm py-2.5"
                  >
                    {method?.action}
                  </Button>
                </a>
              ) : method?.type === 'email' ? (
                <a
                  href={`mailto:${method?.primary}`}
                  className="block w-full"
                >
                  <Button
                    variant="default"
                    fullWidth
                    className="font-semibold bg-white text-primary hover:bg-white/90 rounded-lg text-sm py-2.5"
                  >
                    {method?.action}
                  </Button>
                </a>
              ) : method?.type === 'phone' ? (
                <a
                  href={`tel:${method?.primary.replace(/\s/g, '')}`}
                  className="block w-full"
                >
                  <Button
                    variant="default"
                    fullWidth
                    className="font-semibold bg-white text-primary hover:bg-white/90 rounded-lg text-sm py-2.5"
                  >
                    {method?.action}
                  </Button>
                </a>
              ) : (
                <Button
                  variant="default"
                  fullWidth
                  className="font-semibold bg-white text-primary hover:bg-white/90 rounded-lg text-sm py-2.5"
                >
                  {method?.action}
                </Button>
              )}
            </div>
          ))}
        </div>

        {/* Key Personnel removed per request */}

        {/* Office Locations removed */}

        {/* Emergency Contact removed per request */}
      </div>
    </section>
  );
};

export default ContactMethods;